// 📁 src/redux/slices/dateOptionsSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

// ✅ Types
interface DateOption {
  label: string;
  value: string;
}

interface FetchDateParams {
  page?: number;
  limit?: number;
  searchTerm?: string | null | any;
 MARKETING_ACTIVITY?:any;         // changed toany
  TITLE?:any;
  FILE_NAME?:any;
}


interface TitleState {
  AsapTitleOption: any;
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  currentPage: number;
  limit: number;
}

// ✅ Initial State
const initialState: TitleState = {
  AsapTitleOption: [],
  loading: false,
  error: null,
  hasMore: true,
  currentPage: 1,
  limit: 10,
};

export const FetchASAPTitleOptions = createAsyncThunk(
  "AsapTitleOption",
  async (params: FetchDateParams = {}, { rejectWithValue }) => {
    console.log("page in reducer", params.page);
    try {
       const queryParams: string[] = [];

      if (params.page !== undefined) queryParams.push(`page=${params.page}`);
      if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
      if (params.searchTerm !== undefined)queryParams.push(`searchTerm=${params.searchTerm}`);
      // if (params.DATE?.length) queryParams.push(`DATE=${params.DATE}`);
       if (Array.isArray(params.MARKETING_ACTIVITY)) {
        params.MARKETING_ACTIVITY.forEach(MARKETING_ACTIVITY => {
          queryParams.push(`MARKETING_ACTIVITY=${encodeURIComponent(MARKETING_ACTIVITY)}`);
        });
      }
        if (Array.isArray(params.TITLE)) {
        params.TITLE.forEach(title => {
          queryParams.push(`TITLE=${encodeURIComponent(title)}`);
        });
      }
        if (Array.isArray(params.FILE_NAME)) {
        params.FILE_NAME.forEach(file => {
          queryParams.push(`FILE_NAME=${encodeURIComponent(file)}`);
        });
      }
      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        `${API.GetTitleOfAsap}${queryString}`
      );

      return { data: response.data, page: params.page ?? 1 };
    } catch (err: any) {
      if (err.response?.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

// ✅ Slice
const Titleoptions = createSlice({
  name: "Titleoptions",
  initialState,
  reducers: {
    clearDateOptions: (state) => {
      //   state.TitleOption = [];
      //   state.currentPage = 1;
      //   state.hasMore = true;
      //   state.loading = false;
      //   state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchASAPTitleOptions.pending, (state) => {
        state.loading = true;
        // state.status = "Loading";
      })
      .addCase(FetchASAPTitleOptions.fulfilled, (state, action) => {
        state.loading = false;
        const { data, page } = action.payload;
        const titledata = (data.title_options || []).map((item: string) => ({
          label: item,
          value: item,
        }));
        console.log(data, "titledata222222");
        if (page === 1) {
          state.AsapTitleOption = titledata;
        } else {
          state.AsapTitleOption = [...state.AsapTitleOption, ...titledata];
        }

        state.currentPage = page;
        state.hasMore = data.hasMore;
        state.loading = false;
      })
      .addCase(FetchASAPTitleOptions.rejected, (state) => {
        state.loading = false;
        // state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const { clearDateOptions } = Titleoptions.actions;
export default Titleoptions.reducer;
